import * as HLF from "html-living-framework";
import * as Constants from "../Data/Constants";

export class HieroglyphRain extends PIXI.Container {
    private static readonly SPAWN_DELAY: PIXI.Point = new PIXI.Point(.05, .15);
    private static readonly SPAWN_RECT: PIXI.Rectangle = new PIXI.Rectangle(-330, -300, 330, -300);
    private static readonly SPEED: number = 550;
    private static readonly MAX_Y: number = 300;

    private _pool: PIXI.Sprite[];
    private _active: PIXI.Sprite[];
    private _spawnTimer: number;
    private _spawnDelay: number;
    private _overlay: PIXI.Sprite;
    private _rainContainer: PIXI.Container;

    constructor() {
        super();
        this._spawnTimer = 0;
        this._spawnDelay = HLF.Random.floatBetween(HieroglyphRain.SPAWN_DELAY.x, HieroglyphRain.SPAWN_DELAY.y);

        this._pool = new Array<HLF.AnimatedSprite>();
        this._active = new Array<HLF.AnimatedSprite>();

        this._rainContainer = new PIXI.Container();
        this.addChild(this._rainContainer);

        this._overlay = HLF.PixiUtils.makeSprite("empty-pixel", Constants.SPRITESHEET_UI);
        this._overlay.scale.set(702, 499);
        this._overlay.tint = 0x1441A0;
        this._overlay.alpha = 0.3;
        this.addChild(this._overlay);

        this.prepopulate();
    }

    public update(pDeltaTime: number): void {
        for (let i = 0; i < this._active.length; ++i) {
            this._active[i].position.y += HieroglyphRain.SPEED * pDeltaTime;
        }
        this._spawnTimer += pDeltaTime;
        while (this._spawnTimer >= this._spawnDelay) {
            this._spawnTimer -= this._spawnDelay;
            this._spawnDelay = HLF.Random.floatBetween(HieroglyphRain.SPAWN_DELAY.x, HieroglyphRain.SPAWN_DELAY.y);
            this.spawnRain();
            this._active[this._active.length - 1].position.y += HieroglyphRain.SPEED * this._spawnTimer;
        }
        for (let i = this._active.length - 1; i >= 0; --i) {
            if (this._active[i].position.y >= HieroglyphRain.MAX_Y) {
                const rain: PIXI.Sprite = this._active[i];
                this._active.splice(i, 1);
                this._rainContainer.removeChild(rain);
                this._pool.push(rain);
            }
        }
    }

    public destroy(pOptions?: boolean | PIXI.DestroyOptions): void {
        for (let i = 0; i < this._pool.length; ++i) {
            this._pool[i].destroy();
        }
        delete this._pool;
        for (let i = 0; i < this._active.length; ++i) {
            this._active[i].destroy();
        }
        delete this._active;
        super.destroy(pOptions);
    }

    private prepopulate(): void {
        this.update(3);
    }

    private spawnRain(): void {
        const rain: PIXI.Sprite = this.getRainParticle();
        rain.position.set(
            HLF.Random.floatBetween(HieroglyphRain.SPAWN_RECT.x, HieroglyphRain.SPAWN_RECT.width),
            HLF.Random.floatBetween(HieroglyphRain.SPAWN_RECT.y, HieroglyphRain.SPAWN_RECT.height),
        );
        rain.scale.set(HLF.Random.floatBetween(0.7, 1));
        this._active.push(rain);
        this._rainContainer.addChild(rain);
    }

    private getRainParticle(): PIXI.Sprite {
        let rain: PIXI.Sprite;
        const sheet: string = Constants.SPRITESHEET_HIERO_PREFIX + "00";
        const asset: string = "rain-0" + HLF.Random.intBetween(0, 3);
        if (this._pool.length > 0) {
            rain = this._pool.pop()!;
            rain.texture = PIXI.loader.resources[sheet].textures![asset];
        }
        else {
            rain = HLF.PixiUtils.makeSprite(asset, sheet);
        }
        return rain;
    }
}
